export default __webpack_public_path__ + "static/media/maleta.aa282b70.svg";